export enum PreviewType {
    PDF = "pdf",
    DEFAULT = "default"
}